<template>
  <div class="p-organization-list__item">
    <div
      class="p-organization-list__link"
      v-bind:class="{ 'p-organization-list__link--disable': !isActive }"
      @click="click"
    >
      <div class="p-organization-list__inner">
        <div class="p-organization-list-company">
          <h2
            v-if="item.organizationName"
            class="p-organization-list__title p-organization-list-company__name c-text--ellipsis"
          >
            {{ item.organizationName }}
          </h2>
          <p class="p-organization-list-company__id">
            SaaS顧客管理ID :
            <template v-if="item.saasId">
              {{ item.saasId }}
            </template>
            <template v-else>
              設定なし
            </template>
            / 組織ID : {{ item.organizationId }}
          </p>
        </div>
        <dl class="p-organization-list-date">
          <template
            v-if="item.subscription && item.subscription.expirationDate"
          >
            <dt class="p-organization-list-date__title">
              {{ planTitle }} 有効期限
            </dt>
            <dd
              v-if="item.subscription && item.subscription.expirationDate"
              class="c-text--date"
            >
              {{ item.subscription.expirationDate | dateText('YYYY.MM.DD') }}
            </dd>
            <slot name="button"></slot>
          </template>
          <template v-else>
            <dt class="p-organization-list-date__title">
              {{ planTitle }}
            </dt>
          </template>
        </dl>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      required: true
    },
    isActive: {
      type: Boolean,
      required: true
    },
    planTitle: {
      type: String,
      required: true
    }
  },
  methods: {
    click() {
      // organizationIdを保存する
      this.$store.dispatch('view/setOrganizationId', this.item.organizationId);

      this.$router.push({ name: 'projects' });
    }
  }
};
</script>
